/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Loop_Modes_TitleInputs */

const en_mk_loop_modes_title = /** @type {(inputs: Mk_Loop_Modes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three execution modes`)
};

const id_mk_loop_modes_title = /** @type {(inputs: Mk_Loop_Modes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiga mode eksekusi`)
};

/**
* | output |
* | --- |
* | "Three execution modes" |
*
* @param {Mk_Loop_Modes_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_loop_modes_title = /** @type {((inputs?: Mk_Loop_Modes_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Loop_Modes_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_loop_modes_title(inputs)
	return en_mk_loop_modes_title(inputs)
});